import React from 'react';

const PeopleIcon = () => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.9778 6.36667C5.9778 7.3976 5.14206 8.23333 4.11113 8.23333C3.0802 8.23333 2.24447 7.3976 2.24447 6.36667C2.24447 5.33574 3.0802 4.5 4.11113 4.5C5.14206 4.5 5.9778 5.33574 5.9778 6.36667ZM1 11.4136C1 9.88627 2.23813 8.64815 3.76543 8.64815H4.45679C4.79406 8.64815 5.11722 8.70852 5.41606 8.81905C4.35742 9.57068 3.66667 10.8065 3.66667 12.2037C3.66667 12.4096 3.69667 12.6085 3.75256 12.7963H2.38271C1.61906 12.7963 1 12.1772 1 11.4136ZM14.2474 12.7963H15.6173C16.3809 12.7963 17 12.1772 17 11.4136C17 9.88627 15.7619 8.64815 14.2346 8.64815H13.5432C13.2059 8.64815 12.8828 8.70852 12.5839 8.81905C13.6426 9.57068 14.3333 10.8065 14.3333 12.2037C14.3333 12.4096 14.3033 12.6085 14.2474 12.7963ZM15.7556 6.36667C15.7556 7.3976 14.9198 8.23333 13.8889 8.23333C12.858 8.23333 12.0222 7.3976 12.0222 6.36667C12.0222 5.33574 12.858 4.5 13.8889 4.5C14.9198 4.5 15.7556 5.33574 15.7556 6.36667Z'
      fill='#062471'
    />
    <path
      d='M4.55554 12.2037C4.55554 9.91276 6.41273 8.05557 8.70369 8.05557H9.29628C11.5872 8.05557 13.4444 9.91276 13.4444 12.2037C13.4444 13.3492 12.5158 14.2778 11.3704 14.2778H6.62962C5.48414 14.2778 4.55554 13.3492 4.55554 12.2037Z'
      fill='#0D47D9'
    />
    <circle cx='8.84445' cy='5.29556' r='2.57333' fill='#0D47D9' />
  </svg>
);

export default PeopleIcon;
